import { render, staticRenderFns } from "./PriceUnit.vue?vue&type=template&id=2c90add0&scoped=true&"
import script from "./PriceUnit.vue?vue&type=script&lang=js&"
export * from "./PriceUnit.vue?vue&type=script&lang=js&"
import style0 from "./PriceUnit.vue?vue&type=style&index=0&id=2c90add0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c90add0",
  null
  
)

export default component.exports